export default __webpack_public_path__ + "static/media/lose.d9990146.png";